import { Injectable } from '@angular/core';
import {Subject, Observable, BehaviorSubject} from 'rxjs';
import {INodeOptions} from "@app/workflow-common/diagram-view2/models/node.model";

export interface NodeParamType {
    nodeOptions?: INodeOptions,
}
@Injectable()
export class DiagramService
{
    private _diagram$: BehaviorSubject<NodeParamType> = new BehaviorSubject<NodeParamType>({});
    private _nodeUpdated$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
    private _addNode$: Subject<any> = new Subject<any>();
    private _updateNode$: Subject<any> = new Subject<any>();
    private _deleteNode$: Subject<any> = new Subject<any>();
    private _markDeletableNodes$: BehaviorSubject<string> = new BehaviorSubject<string>('');
    private _autoSave$: Subject<boolean> = new Subject<boolean>();
    private _adjustPositionY$: Subject<any> = new Subject<any>();

    get diagram$(): Observable<NodeParamType> {
        return this._diagram$.asObservable()
    }

    get markDeletableNodes$(): Observable<string> {
        return this._markDeletableNodes$.asObservable();
    }

    get nodeUpdated$(): Observable<boolean> {
        return this._nodeUpdated$.asObservable();
    }

    get addNode$(): Observable<any> {
        return this._addNode$.asObservable()
    }

    get updateNode$(): Observable<any> {
        return this._updateNode$.asObservable()
    }

    get deleteNode$() {
        return this._deleteNode$.asObservable();
    }

    get autoSave$() {
        return this._autoSave$.asObservable();
    }

    get adjustPositionY$() {
        return this._adjustPositionY$.asObservable();
    }

    setAdjustPositionY(elem) {
        this._adjustPositionY$.next(elem);
    }

    setParams(params: NodeParamType) {
        this._diagram$.next(params);
    }

    isNodeUpdated() {
        this._nodeUpdated$.next(true);
    }

    addNewNode(parentId:string, node:any) {
        this._addNode$.next({
            parentId,
            node,
        });
    }

    updateNode(id:string, node:any) {
        this._updateNode$.next({
            id: id,
            node,
        })
    }

    deleteNode(parentId:string, index:number = 0) {
        this._deleteNode$.next({
            parentId: parentId,
            index,
        })
    }

    markDeletableNodes(id:string) {
        this._markDeletableNodes$.next(id);
    }

    autoSave(doSave:boolean) {
        this._autoSave$.next(doSave);
    }
}
